/*
 *
 *@description:
 *@modifyContent:
 *@author: qiuhongyang
 *@date: 2020-07-08 13:08:46
 *
*/

/**
 * 判断长度
 * @param str 
 */
function getStrLen(str: any) {
    if (str == null) return 0;

    if (typeof str != "string") {
        str += "";
    }
    return str.replace(/[^\x00-\xff]/g, "01").length;
}

/**
 * 判断是否为中文
 * @param str 
 */
function isChinese(str: string) {
    if (/^[\u4e00-\u9fa5]+$/.test(str)) {
        return true;
    }
}

/**
 * 顶部搜索相关
 */
function search() {
    let searchResult: JQuery = $("#ly_search_form .search-result");
    let codeSubmit: JQuery = $("#ly_search_form .ly_code_submit");
    $("#code_suggest").on('keyup', function (e) {
        let keyword: any = $(this).val();
        if (!keyword) { 
            searchResult.fadeOut();
        } else {
            let $key: JQuery = searchResult.find(".text-red");

            if (getStrLen(keyword) > 8) {
                if (isChinese(keyword)) {
                    keyword = keyword.substr(0, 4) + '...';
                } else {
                    keyword = keyword.substr(0, 6) + '...';
                }
            }
            $key.text('“' + keyword + '”');
            searchResult.fadeIn();
            if (e.keyCode === 13) {
                window.open(`http://so.eastmoney.com/CArticle/s?KeyWord=${encodeURI(keyword)}`);
            }
        }
    })

    $("#code_suggest").blur(function () {
        searchResult.fadeOut();
    })

    codeSubmit.click(function (e) {
        e.stopPropagation();
        e.preventDefault();
        let keyword: any = $('#code_suggest').val();
        if (!keyword) {
            window.open("http://so.eastmoney.com/");
        }
        window.open(`http://so.eastmoney.com/CArticle/s?KeyWord=${encodeURI(keyword)}`);
    })

    searchResult.on('click', 'div', function () {
        let item: number = $(this).index();
        let keyword: any = $('#code_suggest').val();
        if (item == 1) {
            window.open(`http://so.eastmoney.com/CAccount/s?KeyWord=${encodeURI(keyword)}`);
        } else {
            window.open(`http://so.eastmoney.com/CArticle/s?KeyWord=${encodeURI(keyword)}`);
        }
    });

    $(document).ready(function () {
        function textFill(input:any) {
            var originalvalue = input.val();
            input.focus(function () {
                if ($.trim(input.val()) == originalvalue) {
                    input.val('');
                    input.css({ 'color': '#000' })
                }
            });
            input.blur(function () {
                if ($.trim(input.val()) == '') {
                    input.val(originalvalue);
                    input.css({ 'color': '#757575' })
                }
            });
        }
        if (!('placeholder' in document.createElement('input'))) {
            $("#code_suggest").attr("value", "搜路演/上市公司");
            $('#code_suggest').css({ 'color': '#757575' })
            textFill($('#code_suggest'));
        };

    });
}

export default search;